import { Pipe, PipeTransform } from '@angular/core';
import { FormControl, ValidationErrors } from '@angular/forms';

@Pipe({
  name: 'sgErrorMessage',
  standalone: false,
})
export class SgErrorMessagePipe implements PipeTransform {
  transform(control: FormControl, obj: ValidationErrors): string {
    let errorMessage: string;
    if (control.errors) {
      Object.keys(control.errors).forEach((err) => {
        errorMessage = obj[err];
      });
    }
    return errorMessage;
  }
}
